<p-panel [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="header">
        <div class="d-flex h4">
            Cards you've purchased
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-dataView [value]="customerService.publicCustomer.value.giftCardsPurchased"
            [paginator]="customerService.publicCustomer.value.giftCardsPurchased?.length > 5" [rows]="5">
            <ng-template let-rec pTemplate="listItem">
                <div class="w-100">
                    <div class="d-flex w-100">
                        <div class="ms-1">
                            {{rec.venueName}}
                        </div>
                        <div class="ms-auto">
                            <fa-icon [icon]='["far","badge-dollar"]' class="me-1"></fa-icon> {{rec.transactionAmount |
                            currency}}
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="ms-1">
                            {{app.moment(rec.transactionDateTime).format('l')}} sent to {{rec.recipientName}}
                            ({{rec.recipientEmail}})
                        </div>
                        <div class="ms-auto p-text-right">
                            <span *ngIf="!rec.activated">not yet activated</span>
                            <span *ngIf="rec.activated">activated</span>
                        </div>
                    </div>
                </div>
        
            </ng-template>
            <ng-template pTemplate="empty">
                <div class="d-flex w-100">
                    <div class="mx-auto">
        
                    </div>
                </div>
            </ng-template>
        </p-dataView>
    </ng-template>
</p-panel>
